import get from 'get-value';
import {
    MARKETING_RESET_REDIRECT,
    MARKETING_SET_LOCK_TICKET
} from '../../actions/marketing/actionMarketingLockTicket';
import {marketingWebsocketCommands} from '../../constants/marketingWebsocketCommands';
import {MARKETING_LIST_FETCH} from '../../actions/marketing/actionMarketingList';

export const marketingList = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    listData: [],
    pages: 0,
    isNextFromPivot: true,
    isNextPage: false,
}, action) => {
    switch (action.type) {
        case MARKETING_LIST_FETCH: {
            return Object.assign({}, state, {isTableLoading: true});
        }
        case marketingWebsocketCommands.MARKETING_LIST_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    listData: get(action, 'payload.result.data', {default: []}),
                    pages: get(action, 'payload.result.pages', {default: 0}),
                    isNextPage: get(action, 'payload.result.isNextPage', false),
                    isNextFromPivot: get(action, 'payload.result.isNextFromPivot', false),
                    correlationId
                });
            }
        }
        case marketingWebsocketCommands.MARKETING_LIST_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {isTableLoading: false, correlationId});
            }
        }
        default:
            return state;
    }
};

export const marketingListOrderLockTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case MARKETING_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case marketingWebsocketCommands.MARKETING_TICKET_LOCKED_ERROR:
        case marketingWebsocketCommands.MARKETING_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case marketingWebsocketCommands.MARKETING_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case MARKETING_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
